import { Container, Row } from '@uswitch/ev-core/react'
import Column from './column'

const ProsAndCons = ({ pros, cons, mobileColumns = 1, desktopColumns = 2 }) => (
  <Container>
    <Row cols={[mobileColumns, desktopColumns]}>
      <Column {...pros} variant='pros' />
      <Column {...cons} variant='cons' />
    </Row>
  </Container>
)

export default ProsAndCons

ProsAndCons.propsSchema = {
  type: 'object',
  properties: {
    pros: {
      type: 'object',
      default: {
        items: ['test 1', 'test 2'],
        title: 'pros title',
      },
    },
    cons: {
      type: 'object',
      default: {
        items: ['test 3', 'test 4'],
        title: 'cons title',
      },
    },
  },
}
